import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { toast } from "react-toastify";
import { BiSolidFileExport } from "react-icons/bi";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { Menu, MenuItem, ListItemIcon, Divider } from "@mui/material";
import { HiMiniArrowDownTray } from "react-icons/hi2";
import { HiMiniArrowUpTray } from "react-icons/hi2";
import { IconButton } from "@mui/material";
import InventoryLog from "./InventoryLog";
import { format } from "date-fns";
import { MdOutlineManageHistory } from "react-icons/md";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import StockInModal from "./StockInModal";
const dummyData = [
  {
    category: "Electronics",
    subcategory: "Mobile Phones",
    quantity: 120,
    status: "In Stock",
  },
  {
    category: "Electronics",
    subcategory: "Laptops",
    quantity: 45,
    status: "Low Stock",
  },
  {
    category: "Electronics",
    subcategory: "Headphones",
    quantity: 300,
    status: "In Stock",
  },
  {
    category: "Electronics",
    subcategory: "Smart Watches",
    quantity: 0,
    status: "Out of Stock",
  },

  {
    category: "Fashion",
    subcategory: "Men's Shirts",
    quantity: 150,
    status: "In Stock",
  },
  {
    category: "Fashion",
    subcategory: "Women's Dresses",
    quantity: 75,
    status: "In Stock",
  },
  {
    category: "Fashion",
    subcategory: "Shoes",
    quantity: 20,
    status: "Low Stock",
  },
  {
    category: "Fashion",
    subcategory: "Bags",
    quantity: 0,
    status: "Out of Stock",
  },

  {
    category: "Home Appliances",
    subcategory: "Refrigerators",
    quantity: 10,
    status: "Low Stock",
  },
  {
    category: "Home Appliances",
    subcategory: "Washing Machines",
    quantity: 5,
    status: "Low Stock",
  },
  {
    category: "Home Appliances",
    subcategory: "Microwaves",
    quantity: 25,
    status: "In Stock",
  },
  {
    category: "Home Appliances",
    subcategory: "Air Conditioners",
    quantity: 0,
    status: "Out of Stock",
  },

  {
    category: "Groceries",
    subcategory: "Rice",
    quantity: 500,
    status: "In Stock",
  },
  {
    category: "Groceries",
    subcategory: "Wheat Flour",
    quantity: 250,
    status: "In Stock",
  },
  {
    category: "Groceries",
    subcategory: "Cooking Oil",
    quantity: 75,
    status: "Low Stock",
  },
  {
    category: "Groceries",
    subcategory: "Snacks",
    quantity: 0,
    status: "Out of Stock",
  },

  {
    category: "Sports",
    subcategory: "Cricket Bats",
    quantity: 40,
    status: "In Stock",
  },
  {
    category: "Sports",
    subcategory: "Footballs",
    quantity: 15,
    status: "Low Stock",
  },
  {
    category: "Sports",
    subcategory: "Badminton Rackets",
    quantity: 0,
    status: "Out of Stock",
  },
  {
    category: "Sports",
    subcategory: "Gym Equipment",
    quantity: 25,
    status: "In Stock",
  },
];

const Inventory = () => {
    const navigate=useNavigate()
  const{tab}=useParams()
  const [data, setData] = useState([...dummyData]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [selectedData, setSelecetdData] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const actionMenuOpen = Boolean(anchorEl);
  const[stockInModal,setStockInModal]=useState(false)
  const[isStockIn,setIsStockIn]=useState(true)
  const [stockParam, setStockParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });
  const [logParam, setLogParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
    start_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
  });
  const handleActionClick = (event, item) => {
    setAnchorEl(event.currentTarget);
  };

  const handleActionClose = () => {
    setAnchorEl(null);
  };

  const handleToggleStockInModal=()=>{
    if(stockInModal){
      setSelecetdData(null)
    }
    setStockInModal(!stockInModal)
  }
  const handlePageChange = (page) => {
    setStockParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setStockParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleAfterStockIn=()=>{
    handleToggleStockInModal()
  }

  return (
    <div>
      <div className="mb-2 d-flex justify-content-end align-items-center gap-2">
        <ul
          className="nav flex-row custom-nav2 shadow-sm"
          style={{
            backgroundColor: "rgba(255,255,255) !important",
            backdropFilter: "blur(4px)",
            border: "1px solid #d6d1d1",
            padding: "0.35rem",
          }}
        >
          <li className="nav-item">
            <span
              className={`cursor-pointer nav-link ${
                tab == "stock" ? "active" : ""
              }`}
              style={{ fontSize: "0.75rem" }}
              onClick={() =>navigate("/inventory/stock")}
            >
              <MdOutlineProductionQuantityLimits className="me-1" size="12"/>Stocks
            </span>
          </li>
          <li className="nav-item">
            <span
              className={`cursor-pointer nav-link ${
                tab == "log" ? "active" : ""
              }`}
              style={{ fontSize: "0.75rem" }}
              onClick={() =>navigate("/inventory/log")}
            >
              <MdOutlineManageHistory className="me-1" size="12"/>Log
            </span>
          </li>
        </ul>
        <button
          className="btn btn-success"
          style={{ padding: "0.35rem 0.8rem" }}
        >
          <BiSolidFileExport className="me-1" />
          Export
        </button>
      </div>
      {tab == "stock" ? (
        <div className="card">
          <div className="p-4 d-flex justify-content-between flex-wrap gap-2">
            <div className="flex-fill flex-md-grow-0">
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
            </div>
            <div className="d-flex gap-2 flex-wrap">
              <div>
                <GlobalSearchableDropdown
                  options={[]}
                  selected={null}
                  onSelect={(item) => undefined}
                  placeholder="Category"
                />
              </div>
              <div>
                <GlobalSearchableDropdown
                  options={[]}
                  selected={null}
                  onSelect={(item) => undefined}
                  placeholder="SubCategory"
                />
              </div>
              <div>
                <GlobalSearchableDropdown
                  options={[]}
                  selected={null}
                  onSelect={(item) => undefined}
                  placeholder="Status"
                />
              </div>
            </div>
          </div>
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" />
            </div>
          ) : error ? (
            <div className="text-center my-4 text-danger">{error}</div>
          ) : data && data?.length > 0 ? (
            <div className="table-responsive">
              <table className="table fs-6 mb-0 align-middle">
                <thead className="table-light custom-thead">
                  <tr>
                    <th>Category</th>
                    <th>Sub category</th>
                    <th>Quantity</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={item.id}>
                      <td>{item?.category || "-"}</td>
                      <td>{item?.subcategory || "-"}</td>
                      <td>{item?.quantity || "-"}</td>
                      <td>{item?.status || "-"}</td>
                      <td>
                        <IconButton
                          size="small"
                          onClick={(e) => handleActionClick(e, item)}
                          style={{ border: "1px solid #ddd" }}
                        >
                          <PiDotsThreeOutlineVerticalFill
                            className="text-dark"
                            size={13}
                          />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center my-4">No data found</div>
          )}
          {!loading && data?.length > 0 && (
            <div className="p-4">
              <Pagination
                currentPage={stockParam.page}
                recordsPage={stockParam.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </div>
      ) : tab == "log" ? (
        <InventoryLog param={logParam} setParam={setLogParam} />
      ) : (
        <div className="text-center my-3">Selecet tab</div>
      )}

      <Menu
        anchorEl={anchorEl}
        open={actionMenuOpen}
        onClose={handleActionClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            borderRadius: "6px", // lighter radius
            padding: "0.15rem 0",
            minWidth: "130px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)", // very light shadow
          },
        }}
      >
        <MenuItem
          onClick={() => {
            setIsStockIn(true)
            handleToggleStockInModal()
            handleActionClose();
          }}
          sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
        >
          <ListItemIcon>
            <HiMiniArrowDownTray size={14} />
          </ListItemIcon>
          Stock In
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsStockIn(false)
            handleToggleStockInModal()
            handleActionClose();
          }}
          sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
        >
          <ListItemIcon>
            <HiMiniArrowUpTray size={14} />
          </ListItemIcon>
          Stock Out
        </MenuItem>
        <Divider sx={{ my: 0.3 }} />

        <MenuItem
          onClick={() => {
            handleActionClose();
          }}
          sx={{ padding: "5px 14px", fontSize: "0.85rem" }}
        >
          <ListItemIcon>
            <FiEdit2 size={14} />
          </ListItemIcon>
          Edit
        </MenuItem>
      </Menu>

      <StockInModal
      open={stockInModal}
      onClose={handleToggleStockInModal}
      onSubmit={handleAfterStockIn}
      stockData={selectedData}
      isStockIn={isStockIn}
      />
    </div>
  );
};

export default Inventory;
